import { asyncType } from '../types';

export const SIGN_IN = asyncType('SIGN_IN');
export const SIGN_UP = asyncType('SIGN_UP');
export const CHECK_EMAIL = asyncType('CHECK_EMAIL');
